import React, { useEffect } from "react";
import { useParams, Navigate, Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { LEGAL, LEGAL_LINKS, LEGAL_HEADING } from "./legalContent";
import Seo from "@/components/Seo";

export default function LegalPage() {
  const { slug } = useParams();
  const { lang } = useApp();
  const set = LEGAL[lang] || LEGAL.en;
  const doc = set[slug];
  useEffect(() => { window.scrollTo(0, 0); }, [slug]);

  if (!doc) return <Navigate to="/legal/privacy" replace />;

  return (
    <div className="pt-32 md:pt-40 pb-24 px-5 md:px-10 min-h-[70vh]" data-testid={`legal-${slug}`}>
      <Seo title={doc.title} description={doc.intro ? doc.intro.slice(0, 300) : doc.title} />
      <div className="max-w-6xl mx-auto grid md:grid-cols-12 gap-10 lg:gap-16">
        {/* Side nav */}
        <aside className="md:col-span-3">
          <p className="text-[10px] uppercase tracking-[0.24em] text-muted mb-4">{LEGAL_HEADING[lang] || LEGAL_HEADING.en}</p>
          <ul className="space-y-2.5">
            {LEGAL_LINKS.map((l) => (
              <li key={l.slug}>
                <Link
                  to={`/legal/${l.slug}`}
                  data-testid={`legal-nav-${l.slug}`}
                  className={`text-sm transition-colors ${l.slug === slug ? "text-ink font-medium" : "text-muted hover:text-ink"}`}
                >
                  {l.label[lang] || l.label.en}
                </Link>
              </li>
            ))}
          </ul>
        </aside>

        {/* Content */}
        <article className="md:col-span-9 max-w-2xl">
          <h1 className="font-display font-light text-4xl md:text-5xl mb-6">{doc.title}</h1>
          {doc.intro && <p className="text-ink/60 font-light leading-relaxed mb-10">{doc.intro}</p>}
          <div className="space-y-8">
            {doc.sections.map((s, i) => (
              <section key={i}>
                {s.h && <h2 className="text-lg font-medium mb-3">{s.h}</h2>}
                <div className="space-y-2">
                  {s.p.map((para, j) => (
                    <p key={j} className="text-sm text-ink/70 font-light leading-relaxed">{para}</p>
                  ))}
                </div>
              </section>
            ))}
          </div>
        </article>
      </div>
    </div>
  );
}
